import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote, User } from 'lucide-react';
import './TestimonialsSection.css';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonialsData = [
    {
      id: 'testimonial-1',
      name: 'Sandip Dutta',
      role: 'Administrar',
      company: 'BPPS Kokrajhar' ,
      content: 'The ERP system transformed our school management. Student data, attendance, and grades are now seamlessly integrated. The support team is exceptional.',
      rating: 5
    },
    {
      id: 'testimonial-2',
      name: 'Dhanswrang Mwshahary',
      role: 'Principal',
      company: 'BMS Kokrajhar',
      content: 'Their RFID attendance system with 6-meter range solved our large facility challenges. The offline backup feature is exceptional and saved us multiple times.',
      rating: 5
    }
    // {
    //   id: 'testimonial-3',
    //   name: 'Lisa Chen',
    //   role: 'Operations Manager',
    //   company: 'EduTech Solutions',
    //   content: 'Professional facial recognition system with impressive accuracy. The AI integration capabilities exceeded our expectations and improved our workflow significantly.',
    //   rating: 5,
    //   image: '/api/placeholder/64/64'
    // }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === testimonialsData.length - 1 ? 0 : prev + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === 0 ? testimonialsData.length - 1 : prev - 1
    );
  };

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        className={`testimonials__star ${index < rating ? 'testimonials__star--filled' : ''}`}
        size={20}
      />
    ));
  };

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials__container">
        <div className="testimonials__header">
          <h2 className="testimonials__title">What Our Clients Say</h2>
          <p className="testimonials__subtitle">
            Trusted by educational institutions and businesses across Northeast India
          </p>
        </div>

        <div className="testimonials__content">
          <button 
            className="testimonials__nav testimonials__nav--prev"
            onClick={prevTestimonial}
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={24} />
          </button>

          <div className="testimonials__card">
            <Quote className="testimonials__quote-icon" />
            <div className="testimonials__card-content">
              <div className="testimonials__rating">
                {renderStars(testimonialsData[currentTestimonial].rating)}
              </div>
              <p className="testimonials__text">
                {testimonialsData[currentTestimonial].content}
              </p>
              <div className="testimonials__author">
                <div className="testimonials__author-icon">
                  <User size={32} />
                </div>
                <div className="testimonials__author-info">
                  <h4 className="testimonials__author-name">
                    {testimonialsData[currentTestimonial].name}
                  </h4>
                  <p className="testimonials__author-role">
                    {testimonialsData[currentTestimonial].role}, {testimonialsData[currentTestimonial].company}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <button 
            className="testimonials__nav testimonials__nav--next"
            onClick={nextTestimonial}
            aria-label="Next testimonial"
          >
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="testimonials__indicators">
          {testimonialsData.map((_, index) => (
            <button
              key={index}
              className={`testimonials__indicator ${index === currentTestimonial ? 'testimonials__indicator--active' : ''}`}
              onClick={() => goToTestimonial(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
